<template>
	<edit-layout @save="save()" @cancel="$emit('browsMode')" v-loading.fullscreen.lock="loading" class="pdf-form">
		<el-form label-position="left" label-width="140px">
			<el-form-item label="故事名稱" required>
				<el-input v-model="story_name" placeholder="幫你的故事想個響亮的名字吧"></el-input>
			</el-form-item>
			<el-form-item label="DFC四步驟學習單" required>
				<div class="row" align-y="top" gutter="10">
					<el-button v-if="previewURL" type="text" @click="dialogVisible=true" class="color-blue1">點選預覽</el-button>
					<el-upload :file-list="pdf_list" :action="postURL" :limit="1" accept="application/pdf" class="upload-button" :on-success="handleSuccess" :on-remove="handleRemove" :on-preview="handlePreview" :before-upload="beforeUpload">
						<el-popover trigger="hover" title="提示" placement="right-start">
							<i class="el-icon-info" style="color:red;">&nbsp;請由下方連結下載空白學習單</i>
							<el-button slot="reference" type="primary" class="upload-button button-tp bg-blue1 color-white" size="mini">上傳</el-button>
						</el-popover>
						<small slot="tip"><br /><em>*只能上傳PDF文件，且不超過5MB</em></small>
					</el-upload>
				</div>
			</el-form-item>
		</el-form>
		<div>*空白DFC四步驟學習單請
			<a href="https://drive.google.com/file/d/1erVMeoIAGkDLHBqEvdx9MezBsgNrIDMs/view?usp=sharing" :download="`${transformStoryAccount(editStoryData.account)}-${editStoryData.story_name || ''}-2.3_步驟_小學生公益行動_DFC_挑戰_學習單.docx`" target="_blank" class="color-blue1">由此</a>
			下載
		</div>
		<div class="tips">*請上傳PDF檔案，可以看到
			<a href="https://sofree.cc/word-convert-pdf" target="_blank" class="color-blue1">如何將Word檔案另存成PDF檔</a>
		</div>
		<el-dialog :visible.sync="dialogVisible">
			<iframe :src="previewURL" frameborder="0" width="100%" height="500px"></iframe>
		</el-dialog>
	</edit-layout>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import EditLayout from "./EditLayout.vue";
import API from "@/api";

export default {
	data() {
		return {
			loading: false,
			dialogVisible: false,
			id: "",
			account: "",
			story_name: "",
			pdf_list: []
		};
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		postURL() {
			return `${API.baseURL}/api/upload/pdf/${this.account}`;
		},
		previewURL() {
			const { url } = (this.pdf_list && this.pdf_list[0]) || new Object;
			return url.replace("https", "http") || "";
		}
	},
	methods: {
		...mapMutations("story", ["updateEditStoryData"]),
		...mapActions("story", ["updateStory", "checkProgress"]),
		init() {
			this.id = this.editStoryData.id;
			this.account = this.editStoryData.account;
			this.story_name = this.editStoryData.story_name;
			this.pdf_list = this.editStoryData.pdf_list;
		},
		beforeUpload(file) {
			this.loading = true;
		},
		handleSuccess(response, file, fileList) {
			this.pdf_list = fileList.map(file => {
				return {
					name: file.name,
					url: file.response.Location
				};
			});
			this.loading = false;
		},
		handleRemove(file, fileList) {
			this.pdf_list = fileList;
		},
		handlePreview(file) {
			this.dialogVisible = true;
		},
		async save() {
			let data = {
				id: this.id,
				story_name: this.story_name,
				pdf_list: this.pdf_list
			};
			this.updateEditStoryData(data);
			data.progress = await this.checkProgress();
			await this.updateStory(data);
			this.$emit("browsMode");
			this.$message.success("儲存成功");
		},
		transformStoryAccount(val) {
			return val;
			// return val && val.match(/[0-9]+/)[0] || "";
		},
	},
	created() {
		this.init();
	},
	components: {
		EditLayout
	}
};
</script>

<style lang="scss" scoped>
.pdf-form {
	font-size: 14px;
	.tips {
		font-size: 12px;
	}
}
</style>